import { APP_URL } from "$lib/env"
import { toast } from "svelte-sonner"

String.prototype.toBoolean = function (): boolean {
  return this == "1" || this == "true"
}

String.prototype.toInt = function (): number {
  return +this
}

String.prototype.toNumber = function (): number {

  const raw = this.replace(/,/g, "")
  if (!/^\d*\.?\d*$/.test(raw)) return 0

  const value = Number(raw)

  return Number.isFinite(value) ? value : 0
}

String.prototype.toNumeric = function (): string {

  const raw = this.replace(/,/g, "")
  if (raw == "") return ""
  if (!/^\d*\.?\d*$/.test(raw)) return "0"

  const [integer, fraction] = raw.split(".")
  const formatted = Number(integer || "0").toLocaleString("en-US")

  return fraction === undefined ? formatted : `${formatted}.${fraction}`
}

String.prototype.toPhone = function (): string {

  const phone = this.replace(/[-+]/g, "")

  if (phone.startsWith("08")) {
    return phone.replace(/^08/, "628")
  }

  if (phone.startsWith("62")) {
    return phone
  }

  return phone
}

String.prototype.toMoney = function (): string {
  return Number(this).toLocaleString("en-US")
}

String.prototype.in = function (data: string[]): boolean {
  return data.includes(this.valueOf())
}

String.prototype.padLine = function (maxChar: number): string {

  let result = ""
  let currentLine = ""

  this
    .split(" ")
    .forEach(word => {
      if ((currentLine + word).length <= maxChar) {
        currentLine += (currentLine ? " " : "") + word
      } else {
        result += (result ? "\n" : "") + currentLine
        currentLine = word
      }
    })

  if (currentLine) {
    result += (result ? "\n" : "") + currentLine // Add the last line
  }

  return result
}

String.prototype.formatLine = function (maxChar: number): string {

  const wordWrap = (text: string, limit: number): string[] => {
    if (!text) return [""]

    const words = text.split(/\s+/)
    const lines: string[] = []

    let current = ""
    for (const w of words) {
      if (!current.length) {
        if (w.length <= limit) {
          current = w
        } else {
          // Hard-break very long word
          for (let i = 0; i < w.length; i += limit) {
            const chunk = w.substring(i, i + limit)
            if (chunk.length === limit) lines.push(chunk)
            else current = chunk
          }
        }
      } else if ((current + " " + w).length <= limit) {
        current += " " + w
      } else {
        lines.push(current)
        if (w.length <= limit) {
          current = w
        } else {
          // Hard-break very long word
          let remaining = w
          while (remaining.length > limit) {
            lines.push(remaining.substring(0, limit))
            remaining = remaining.substring(limit)
          }
          current = remaining
        }
      }
    }
    if (current) lines.push(current)
    return lines.length ? lines : [""]
  }

  const formatLine = (line: string): string => {

    const leftMatch = line.match(/\[L\](.*?)(?=\[|$)/)
    const centerMatch = line.match(/\[C\](.*?)(?=\[|$)/)
    const rightMatch = line.match(/\[R\](.*?)(?=\[|$)/)

    const left = leftMatch ? leftMatch[1].trim() : ""
    const center = centerMatch ? centerMatch[1].trim() : ""
    const right = rightMatch ? rightMatch[1].trim() : ""

    if (!line.includes("[L]") && !line.includes("[C]") && !line.includes("[R]")) {
      // No alignment tags: perform simple wrapping by maxChar
      return (line || "").toString().padLine(maxChar)
    }

    // Wrap each segment independently using word wrap up to maxChar
    const leftLines = wordWrap(left, maxChar)
    const centerLines = wordWrap(center, maxChar)
    const rightLines = wordWrap(right, maxChar)

    const lineCount = Math.max(leftLines.length, centerLines.length, rightLines.length)
    const lines: string[] = []

    for (let i = 0; i < lineCount; i++) {
      const ll = leftLines[i] || ""
      const cc = centerLines[i] || ""
      const rr = rightLines[i] || ""

      const row: string[] = Array(maxChar).fill(" ")

      if (cc) {
        const start = Math.max(0, Math.floor((maxChar - cc.length) / 2))
        cc.split("").forEach((ch, j) => {
          if (start + j < maxChar) row[start + j] = ch
        })
      }

      if (rr) {
        const start = Math.max(0, maxChar - rr.length)
        rr.split("").forEach((ch, j) => {
          if (start + j < maxChar) row[start + j] = ch
        })
      }

      if (ll) {
        ll.split("").forEach((ch, j) => {
          if (j < maxChar) row[j] = ch
        })
      }

      lines.push(row.join(""))
    }

    return lines.join("\n")
  }

  return this
    .split("\n")
    .map((line) => formatLine(line))
    .join("\n")
}

String.prototype.url = function (path: string | null = null): string {
  const base = APP_URL
  return path
    ? `${base}/${path}/${this}`
    : `${base}/${this}`
}

String.prototype.toUri = function (): string {
  return encodeURI(this as string)
}

String.prototype.fileExtension = function (): string {
  const url = this.split("?")[0]
  const index = url.lastIndexOf(".")
  return index > -1 ? url.substring(index + 1).toLowerCase() : ""
}

String.prototype.fileOpen = function (extDefault: string = "") {

  const ext = extDefault || this.fileExtension()

  if (ext == "pdf") {
    window.dispatchEvent(new CustomEvent("view-pdf", { detail: this }))
    return
  }

  if (
    ext == "doc" ||
    ext == "docx" ||
    ext == "xls" ||
    ext == "xlsx"
  ) {
    window.dispatchEvent(new CustomEvent("view-doc", { detail: this }))
    return
  }

  if (
    ext == "media" ||
    ext == "jpg" ||
    ext == "jpeg" ||
    ext == "png" ||
    ext == "gif"
  ) {
    window.dispatchEvent(new CustomEvent("view-image", { detail: this }))
    return
  }

  toast.error("File tidak dikenali")
}

String.prototype.linkOpen = function (): void {
  try {

    if (typeof _device == "undefined") {
      throw Error("Fitur ini hanya bisa menggunakan aplikasi")
    }

    _device.open(this)

  } catch (e) {
    toast.info("Akses dibatasi", {
      description: e instanceof Error ? e.message : "Unknown error.",
    })
  }
}
